class HHProductMediaCarousel extends HTMLElement {
  constructor() {
    super()

    this.product_id = this.dataset.productId
    this.suffix = this.dataset.suffix
    this.slider = this.querySelector('.js-product-media-slider')
    this._doSlider = this._doSlider.bind(this)
    this._updateDots = this._updateDots.bind(this)
  }

  connectedCallback() {
    this.$slider = $(this.slider)
    this._attachListeners()
    this._doSlider()
  }

  _doSlider() {
    if (!this.$slider.hasClass('slick-initialized')) {
    if (this.suffix !== 'simple') {
      this.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'slick-dots slick-thumb grid-container',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: true,
              dots: false
            }
          }
        ]
      })
      const _this = this
      this.$slider.on('breakpoint', function (event, slick, breakpoint) {
        if (!breakpoint) {
          _this._updateDots()
        }
      })

      this._updateDots()
    } else {
      this.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        variableWidth: true
      })
    }
  }
  }
  _updateDots() {
    const slides = Array.from(
      this.querySelectorAll('.slick-track .slick-slide:not(.slick-cloned)')
    )
    const dots = Array.from(this.querySelectorAll('.slick-dots li'))
    let element = null
    for (let index = 0; index < dots.length; index++) {
      element = document.createElement('span')
      element.className =
        'product-image-wrapper product-image-wrapper-constrained product-thumb'
      element.innerHTML =
        slides[index].querySelector('.product-slide').innerHTML
      dots[index].querySelector('button').appendChild(element)
    }
  }

  changeMedia(data) {
    let selectedColor = data.variant_details.option1;
    let allMedia = data.other_media;
    let matchingMediaHtml = '';
    var allVariantText = '';
    var storedIds = [];
    // before we start to limit things, we need to make sure it's a color before limiting the options by color
    if ($('.bundle-item-hero__active').length > 0) {
          $('.bundle-item-hero__active').find('.js-swatch__group-label').each(function() {
      var text = $(this).text().trim();
      allVariantText += text + ',';
    });
    if ($('.bundle-item-hero__active').find('.swatch__group--color').length > 0) {
        allVariantText += 'color,';
    } 
  }
  else {
    $('.js-swatch__group-label').each(function() {
      var text = $(this).text().trim();
      allVariantText += text + ',';
    });
    if ($('.swatch__group--color').length > 0) {
      allVariantText += 'color,';
  } 
  }
  if (allVariantText.indexOf('Color') > -1 || allVariantText.indexOf('color') > -1) {
    allMedia.find('.true-img[alt="'+selectedColor+'"]').each(function() {
      let media = $(this); // Wrap the current element with jQuery
      matchingMediaHtml += media.parent().parent().parent().parent().prop('outerHTML');  
  });
}
else {

// Use jQuery's .each() to iterate over the jQuery object
allMedia.find('.true-img').each(function() {
  let media = $(this); // Wrap the current element with jQuery
  let media_id = media.attr('data-media-id') || 'blank';
  let altText = media.attr('alt'); // Get the 'alt' attribute
    // since we have multiple of the same images potentially with no colors, we need to dedupe
    if (storedIds.includes(media_id) && media_id != 'blank') {
    }
    else {
    matchingMediaHtml += media.parent().parent().parent().parent().prop('outerHTML');
    storedIds.push(media_id);
    }
});
}
    var sliderContainer = data.this_slider; // The direct container initialized with Slick
    sliderContainer = $(sliderContainer);
    if (sliderContainer) {
        // Destroy existing Slick instance if present
        
        if ($(sliderContainer).hasClass('slick-initialized')) {
            $(sliderContainer).slick('unslick');
        }

        // Clear and repopulate the container
        sliderContainer.html(matchingMediaHtml);
        // Delay reinitialization to ensure the DOM has updated
            this._doSlider(); // Adjust this method as necessary
    }
  if (data.is_bundle == true) {
    // we need to also update the very first slider under main product panel in case this is desktop
    var bundleSlideContainer = $('.js-product-media-slider').eq(0);
    if (bundleSlideContainer) {
      // Destroy existing Slick instance if present
      
      if ($(bundleSlideContainer).hasClass('slick-initialized')) {
          $(bundleSlideContainer).slick('unslick');
      }
      // Clear and repopulate the container
      bundleSlideContainer.html(matchingMediaHtml);
      
      bundleSlideContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'slick-dots slick-thumb grid-container',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: true,
              dots: false
            }
          }
        ]
      });
// Enhance each dot with a product image, ensuring dots are scoped within bundleSlider
$(bundleSlideContainer).find('.slick-dots li').each(function(index) {
  var $dot = $(this);
  // Ensure we're getting the slides from within the context of bundleSlideContainer
  var $slide = $(bundleSlideContainer).find('.slick-track .slick-slide:not(.slick-cloned)').eq(index);
  var $element = $('<span></span>', {
      class: 'product-image-wrapper product-image-wrapper-constrained product-thumb',
      html: $slide.find('.product-slide').html()
  });
  $dot.find('button').append($element);
});
  }
  }
  }

  _attachListeners() {
    document.addEventListener('product-media::change', (event) => {
      if (this.product_id === event.detail.product_id) {
        this.changeMedia(event.detail)
      }
      if (event.detail.product_id !== event.detail.parent_id && this.product_id === event.detail.parent_id) {
        this.changeMedia(event.detail)
      }
    });
   
  }
}

customElements.define('hh-product-media-carousel', HHProductMediaCarousel)
